var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.6653 18.049L10.6162 12L16.6653 5.95098C17.1116 5.50467 17.1116 4.78105 16.6653 4.33474C16.219 3.88842 15.4953 3.88842 15.049 4.33474L7.38376 12L15.049 19.6653C15.4953 20.1116 16.219 20.1116 16.6653 19.6653C17.1116 19.219 17.1116 18.4953 16.6653 18.049Z","fill":"#142470"}));
}

ArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
